'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/7/29.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _experienceShop = require('redux/modules/experienceShop');

var experienceShopActions = _interopRequireWildcard(_experienceShop);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopMembersDetails = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    promises.push(dispatch(experienceShopActions.getMemberDetails('', params.page, params.memberId)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    memberDetailsData: state.experienceShop.memberDetailsData
  };
}, (0, _extends3.default)({}, experienceShopActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopMembersDetails, _Component);

  function ExperienceShopMembersDetails() {
    (0, _classCallCheck3.default)(this, ExperienceShopMembersDetails);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopMembersDetails).call(this));

    _this.state = {
      orderItem: 'shop',
      direction: '',
      currentPage: 0,
      filter: ''
    };
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopMembersDetails, [{
    key: 'onItemClick',
    value: function onItemClick(clickItem) {
      var _props = this.props;
      var getMemberDetails = _props.getMemberDetails;
      var params = _props.params;
      var _state = this.state;
      var direction = _state.direction;
      var filter = _state.filter;

      var currentDirection = 'ASC';
      var currentFilter = filter;
      switch (clickItem) {
        case 'money':
        /*   if (direction === 'ASC') {
         currentDirection = 'DESC';
         }
         this.setState({
         orderItem: 'money',
         direction: currentDirection
         });
         break;*/
        case 'buyDate':
        /*     if (direction === 'ASC') {
         currentDirection = 'DESC';
         }
         this.setState({
         orderItem: 'buyDate',
         direction: currentDirection
         });
         break;*/
        case 'percent':
        /*   if (direction === 'ASC') {
         currentDirection = 'DESC';
         }
         this.setState({
         orderItem: 'percent',
         direction: currentDirection
         });
         break;*/
        case 'earnMoney':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: clickItem,
            direction: currentDirection
          });
          break;
        default:
          this.setState({
            orderItem: 'shop',
            direction: 'DESC'
          });
      }

      if (getMemberDetails) {
        getMemberDetails(currentFilter, 0, params.memberId, { orderItem: clickItem, direction: currentDirection });
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props2 = this.props;
      var getMemberDetails = _props2.getMemberDetails;
      var params = _props2.params;

      if (getMemberDetails) {
        this.setState({
          currentPage: page
        });
        getMemberDetails('', page, params.memberId);
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch() {
      var getMemberDetails = this.props.getMemberDetails;
      var filter = this.state.filter;

      var value = this.refs.searchInput.value;
      if (getMemberDetails) {
        var currentFilter = filter;
        if (value && value !== '') {
          currentFilter = (0, _extends3.default)({}, filter, { FindValue: value });
        } else {
          delete currentFilter.FindValue;
        }
        this.setState({
          filter: currentFilter
        });
        getMemberDetails(currentFilter, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var memberDetailsData = this.props.memberDetailsData;
      var _state2 = this.state;
      var currentPage = _state2.currentPage;
      var orderItem = _state2.orderItem;

      var styles = require('./ExperienceShopMembersDetails.scss');
      var memberDetailsShow = '';
      var memberBuyProductsShow = '';
      // let memberBuyProductsTotalEarnShow = '';
      var totalPageNumber = 1;
      if (memberDetailsData) {
        var experienceShopMemberDetails = memberDetailsData.experienceShopMemberDetails;
        var experienceShopMemberDetailsError = memberDetailsData.experienceShopMemberDetailsError;
        var experienceShopMemberDetailsBuyProducts = memberDetailsData.experienceShopMemberDetailsBuyProducts;
        var experienceShopMemberDetailsBuyProductsError = memberDetailsData.experienceShopMemberDetailsBuyProductsError;
        var experienceShopMemberDetailsBuyProductsRecordCount = memberDetailsData.experienceShopMemberDetailsBuyProductsRecordCount;
        var experienceShopMemberDetailsBuyProductsPagesize = memberDetailsData.experienceShopMemberDetailsBuyProductsPagesize;

        if (experienceShopMemberDetailsError) {
          memberDetailsShow = _react2.default.createElement(_components.ErrorLabel, { error: experienceShopMemberDetailsError });
          /*      memberBuyProductsTotalEarnShow = (
           <div>
           <div className={styles.sqtxt1}>截止时间:</div>
           <div className={styles.sqtxt2}>
           <span className={styles.tit}>购买总额：¥</span><span className={styles.lit}></span><br/>
           <span className={styles.tit}>佣金提成额：¥</span><span className={styles.lit}></span>
           </div>
           </div>
           ); */
        } else if (experienceShopMemberDetails instanceof Array && experienceShopMemberDetails.length > 0) {
          memberDetailsShow = _react2.default.createElement(
            'div',
            { className: styles.lar_atcoi1 },
            _react2.default.createElement(
              'ul',
              { className: styles.xinxiul },
              _react2.default.createElement(
                'li',
                null,
                '会员姓名：',
                experienceShopMemberDetails[0].name
              ),
              _react2.default.createElement(
                'li',
                null,
                '会员级别：',
                experienceShopMemberDetails[0].level
              ),
              _react2.default.createElement(
                'li',
                null,
                '联系方式：',
                experienceShopMemberDetails[0].mobile
              )
            ),
            _react2.default.createElement(
              'ul',
              { className: styles.totalCU },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  { className: styles.tit },
                  '截止时间：'
                ),
                experienceShopMemberDetails[0].deadlines
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  { className: styles.tit },
                  '购买总额：'
                ),
                '¥',
                _react2.default.createElement(
                  'span',
                  {
                    className: styles.lit },
                  experienceShopMemberDetails[0].totalBuyMoney
                ),
                _react2.default.createElement('br', null)
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  { className: styles.tit },
                  '佣金提成额：'
                ),
                '¥',
                _react2.default.createElement(
                  'span',
                  {
                    className: styles.lit },
                  experienceShopMemberDetails[0].totalEarnMoney
                )
              )
            )
          );
          /*       memberBuyProductsTotalEarnShow = (
           <div>
           <div className={styles.sqtxt1}>截止时间: {experienceShopMemberDetails[0].deadlines}</div>
           <div className={styles.sqtxt2}>
           <span className={styles.tit}>购买总额：¥</span><span
           className={styles.lit}>{experienceShopMemberDetails[0].totalBuyMoney}</span><br/>
           <span className={styles.tit}>佣金提成额：¥</span><span
           className={styles.lit}>{experienceShopMemberDetails[0].totalEarnMoney }</span>
           </div>
           </div>
           ); */
        }
        if (experienceShopMemberDetailsBuyProductsError) {
          memberBuyProductsShow = _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              null,
              'experienceShopMemberDetailsBuyProductsError:'
            ),
            _react2.default.createElement(
              'td',
              null,
              experienceShopMemberDetailsBuyProductsError
            ),
            _react2.default.createElement(
              'td',
              null,
              ''
            ),
            _react2.default.createElement(
              'td',
              null,
              ''
            ),
            _react2.default.createElement(
              'td',
              null,
              ''
            ),
            _react2.default.createElement(
              'td',
              null,
              ''
            )
          );
        } else if (experienceShopMemberDetailsBuyProducts instanceof Array && experienceShopMemberDetailsBuyProducts.length > 0) {
          // console.log(experienceShopMemberDetailsBuyProducts);
          memberBuyProductsShow = experienceShopMemberDetailsBuyProducts.map(function (buyProduct, index) {
            return _react2.default.createElement(
              'tr',
              { key: index },
              _react2.default.createElement(
                'td',
                null,
                buyProduct.productName
              ),
              _react2.default.createElement(
                'td',
                null,
                buyProduct.shop
              ),
              _react2.default.createElement(
                'td',
                null,
                buyProduct.butDate
              ),
              _react2.default.createElement(
                'td',
                null,
                buyProduct.money
              ),
              _react2.default.createElement(
                'td',
                null,
                buyProduct.percent
              ),
              _react2.default.createElement(
                'td',
                null,
                buyProduct.earnMoney
              )
            );
          });
          totalPageNumber = parseInt(experienceShopMemberDetailsBuyProductsRecordCount / experienceShopMemberDetailsBuyProductsPagesize, 10);
          if (experienceShopMemberDetailsBuyProductsRecordCount % experienceShopMemberDetailsBuyProductsPagesize > 0) {
            ++totalPageNumber;
          }
        }
      }

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.larbox },
          _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement(
              'span',
              null,
              '体验店会员信息'
            )
          ),
          memberDetailsShow
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'ul',
          { className: styles.jsdd },
          _react2.default.createElement(
            'li',
            { className: orderItem === 'shop' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('shop');
              } },
            '店铺'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'money' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('money');
              } },
            '购买金额'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'buyDate' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('buyDate');
              } },
            '购买时间'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'percent' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('percent');
              } },
            '佣金比例'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'earnMoney' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('earnMoney');
              } },
            '佣金金额'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.jsallshou },
          _react2.default.createElement('input', { ref: 'searchInput', type: 'text' }),
          _react2.default.createElement(
            'div',
            { onClick: this.onSearch.bind(this) },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/shc.png', alt: '', className: 'img' })
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'table',
          { className: styles.allTable },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { style: { width: '20%' } }),
            _react2.default.createElement('col', { style: { width: '20%' } }),
            _react2.default.createElement('col', { style: { width: '15%' } }),
            _react2.default.createElement('col', { style: { width: '15%' } }),
            _react2.default.createElement('col', { style: { width: '15%' } }),
            _react2.default.createElement('col', { style: { width: '15%' } })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '购买艺品'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买店铺'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买时间'
              ),
              _react2.default.createElement(
                'th',
                null,
                '购买金额'
              ),
              _react2.default.createElement(
                'th',
                null,
                '佣金比例'
              ),
              _react2.default.createElement(
                'th',
                null,
                '提成金额'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            memberBuyProductsShow
          )
        ),
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : ''
      );
    }
  }]);
  return ExperienceShopMembersDetails;
}(_react.Component), _class2.propTypes = {
  memberDetailsData: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  getMemberDetails: _react.PropTypes.func,
  params: _react.PropTypes.object,
  error: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ExperienceShopMembersDetails;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopMembersDetails/ExperienceShopMembersDetails.js
 ** module id = 1473
 ** module chunks = 0
 **/